import { useQuery } from '@apollo/react-hooks';
import { DeviceEnum, OsEnum } from '__generated__/graphql-global-types';
import { purgeVisibility } from 'Libs/Gtm/home';
import { storageFactory } from 'Libs/storageFactory';
import { useCallback, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import AuthStore from 'Store/AuthStore';
import UiStore from 'Store/UiStore';

import styled from 'styled-components';
import { HeaderLinks } from 'Ui';
import {
  getHeaderNavigation,
  getHeaderNavigationVariables,
} from '../__generated__/getHeaderNavigation';
import query from '../headerNavigationQuery';

export const MenuBar = styled.div`
  gap: 2.4rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-family: var(--font-primary);
  align-items: center;
  height: 100%;
  overflow: auto;

  a {
    font-size: 1.2rem;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 100%;
    padding: 0;
    margin: 0;
  }

  &::-webkit-scrollbar {
    width: 0 !important;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const HeaderNavigation = () => {
  const menuDevice: DeviceEnum = isMobile
    ? DeviceEnum.MOBILE
    : DeviceEnum.DESKTOP;

  const { data } = useQuery<getHeaderNavigation, getHeaderNavigationVariables>(
    query,
    {
      variables: { device: menuDevice, os: OsEnum.SITE },
    }
  );

  const links = (data && data.headerNavigation && data.headerNavigation) || [];
  // const home = '/accueil/index/' === window.location.pathname;
  // const homeType = 'ACCEUIL';

  const setPathHeaderMenu = UiStore.useStoreActions(
    (action) => action.setPathHeaderMenu
  );
  const setLinkType = UiStore.useStoreActions((action) => action.setLinkType);
  setPathHeaderMenu(links);

  const linksMenu = links.map((link, index) => {
    const urlLink = link.url;
    const linkUrlWithoutSlash = urlLink.slice(0, -1);
    const urlMatch =
      window.location.pathname === linkUrlWithoutSlash
        ? linkUrlWithoutSlash
        : link.url;
    return {
      label: link.label,
      url: urlMatch,
      color: link.color,
      alt: link.alt,
      type: link.type,
      target: link.target,
    };
  });

  return (
    <>
      <MenuBar data-test="header-links" className="reactHomeMenuV4">
        {linksMenu
          .filter((link) => !!link.label)
          .map((link, index) => {
            return (
              <div
                style={{
                  // height: '7.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                key={index}
              >
                <HeaderLinks
                  to={link.url ?? ''}
                  dataTest="header-link"
                  internal={false}
                  underlinecolor={link.color}
                  style={{
                    color: link.color ? link.color : '',
                  }}
                  onClick={() => {
                    setLinkType(link.type.toUpperCase());
                    purgeVisibility();
                  }}
                >
                  {link.label}
                </HeaderLinks>
              </div>
            );
          })}
      </MenuBar>
    </>
  );
};
